import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '@/app/components/Button';
import Modal from '@/app/components/Modal';
import Icon from '@/app/components/Icon';
import TextSmall from '../../Typography/TextSmall';

function CheckOrderStatus({ useTranslation }) {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [isOpenCheckOrderStatusModal, setIsOpenCheckOrderStatusModal] =
    useState(false);

  const handleCloseCheckOrderStatusModal = (state) =>
    setIsOpenCheckOrderStatusModal(state);

  return !isLoggedIn ? (
    <div className="relative">
      <Button
        type="link"
        className="flex items-center gap-[4px] !p-0"
        onClick={() =>
          setIsOpenCheckOrderStatusModal(!isOpenCheckOrderStatusModal)
        }
      >
        <Icon type="order-status" />
        <TextSmall
          text="Check Order Status"
          className="text-sm lg:text-sm lg:leading-5 text-white font-medium hover:underline"
        />
      </Button>

      <Modal
        type="check-order-status-modal"
        onView={isOpenCheckOrderStatusModal}
        onClose={handleCloseCheckOrderStatusModal}
      />
    </div>
  ) : null;
}

export default CheckOrderStatus;
